<template>
    <label
        :class="{
            'border-red-600': error,
        }"
        class="relative block rounded-8 border border-ash-45 p-3 pt-4 transition-colors duration-300">
        <textarea
            v-model="model"
            placeholder=" "
            v-bind="$attrs"
            class="peer relative h-full w-full resize-none bg-transparent text-ash-200 outline-none" />
        <span
            class="pointer-events-none absolute left-3 top-0 text-16/148 text-ash-300 transition-all duration-300 ease-in-out peer-placeholder-shown:top-3.5 peer-focus:top-0 peer-focus:text-14/148">
            {{ placeholder }}
        </span>
        <Transition name="error-fade">
            <div
                v-if="error"
                class="absolute -bottom-2 right-3 z-10 rounded-4 bg-red-600 px-1 text-12/140 text-white">
                {{ error }}
            </div>
        </Transition>
    </label>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

const model = defineModel({
    type: [String, Number] as PropType<string | number>,
    required: true,
})

defineProps({
    placeholder: {
        type: String as PropType<string>,
        default: '',
    },
    rows: {
        type: Number as PropType<number>,
        default: 5,
    },
    error: {
        type: [String, null] as PropType<string | null>,
        default: null,
    },
})
</script>
